import React, { useRef, useEffect, useState } from 'react';
import paper from 'paper';
import ProgressBar from '../ProgressBar';

const River = ({
  waveCount = 10,
  waveColors = ['blue', 'blue', 'blue', 'blue', 'blue'],
  waveSpeeds = [0.002, 0.003, 0.005, 0.001, 0.008],
  documentBackgroundColor = 'white',
  amps = [2,3,2,3,2],
  counterStart = -10,
  counterIncrement = 0.05,
  bias = (x) => x,
  fillColor = 'black',
  barColor = 'rgba(0,0,0,0.45)',
  texts = [
    {
      text: 'I heard that thing on the radio',
      count: 300,
      fontSize: 50,
    },
    {
      text: 'It got lost in the overflow',
      count: 600,
      fontSize: 50,
    },
    {
      text: 'Now nothing stays still anymore',
      count: 900,
      fontSize: 50,
    },
    {
      text: '',
      count: 1200,
    }
  ],
  content = {
    justification: 'center',
    fontSize: texts[0].fontSize,
  },
}) => {
  const canvasRef = useRef(null);
  const waves = useRef([]);
  const mouseAmplitude = useRef(10);
  const barRef = useRef({ index: 0, counter: 0 });
  const [barProgress, setBarProgress] = useState({ index: 0, counter: 0 });

  const setupWaves = (waves) => {
    for (let i = 0; i < waveCount; i++) {
      const wave = new paper.Path();
      wave.strokeColor = waveColors[i % waveColors.length];
      wave.strokeWidth = Math.random() * 10 + 1;
      waves.push(wave);
    }
    return waves;
  };

  const updateWaves = (waves) => {
    let counter = counterStart;

    waves.forEach((wave, i) => {
      const time = Date.now() * waveSpeeds[i];
      wave.segments = [];
      for (let x = 0; x <= paper.view.size.width; x += 1) {
        const y = mouseAmplitude.current * amps[i] * Math.sin(x * 0.05 + time + i * 20) + paper.view.size.height / 2;
        wave.add(new paper.Point(x, y + bias(counter) ));
        counter += counterIncrement;
      }
    });
  };

  const setupText = () => {
    const displayText = new paper.PointText({
      point: [paper.view.size.width/2, paper.view.size.height/2],
      content: texts[0].text,
      ...content,
    });
    displayText.fillColor = fillColor;
    return displayText;
  };

  useEffect(() => {
    paper.setup(canvasRef.current);

    const displayText = setupText();
    setupWaves(waves.current);

    const onMouseMove = (event) => {
      const mousepoint = event.point;
      displayText.point = mousepoint;
      document.body.style.backgroundColor = documentBackgroundColor;
      mouseAmplitude.current = (paper.view.size.height - event.point.x + event.point.y) / 50;

      const bar = barRef.current;
      if (bar.index < texts.length - 1) bar.counter += 1;
      if (bar.counter > texts[bar.index].count) {
        bar.index += 1;
        displayText.content = texts[bar.index].text;
        displayText.fontSize = texts[bar.index].fontSize;
      }
      setBarProgress({ index: bar.index, counter: bar.counter });
    };

    const onFrame = () => {
      updateWaves(waves.current);
    };

    paper.view.on('mousemove', onMouseMove);
    paper.view.on('frame', onFrame);

    return () => {
      paper.view.off('mousemove', onMouseMove);
      paper.view.off('frame', onFrame);
      paper.project.clear();
    };
  }, []);

  return (
    <div style={{ position: 'relative', width: '100%', height: '100%' }}>
      <canvas ref={canvasRef} style={{ width: '100%', height: '100%', cursor: 'none' }} />
      <ProgressBar
        texts={texts}
        index={barProgress.index}
        counter={barProgress.counter}
        color={barColor}
      />
    </div>
  );
};

export default River;
